import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from 'prosemirror-state';

const ABSTRACT_WORD_LIMIT = 150;

export const AbstractWordLimit = Extension.create({
    name: 'abstractWordLimit',

    addOptions() {
        return {
            onUpdate: null, // Callback when abstract word count changes
        };
    },

    addProseMirrorPlugins() {
        const { options } = this;
        
        return [
            new Plugin({
                key: new PluginKey('abstractWordLimit'),
                view() {
                    return {
                        update(view) {
                            const { doc } = view.state;
                            let abstractWordCount = 0;
                            let inAbstract = false;
                            
                            // Find abstract section and count words
                            doc.descendants((node, _pos) => {
                                // Found abstract heading
                                if (node.type.name === 'heading' && node.attrs.sectionType === 'abstract') {
                                    inAbstract = true;
                                    return true;
                                }
                                
                                // Found another section heading - stop counting
                                if (node.type.name === 'heading' && node.attrs.sectionType && inAbstract && node.attrs.sectionType !== 'abstract') {
                                    inAbstract = false;
                                    return false; // Stop traversing
                                }
                                
                                // Count words in paragraphs within abstract (not text nodes directly)
                                if (inAbstract && node.type.name === 'paragraph') {
                                    const text = node.textContent;
                                    if (text && text.trim()) {
                                        const words = text.trim().match(/\S+/g);
                                        abstractWordCount += words ? words.length : 0;
                                    }
                                }
                                
                                return true;
                            });
                            
                            // Call the callback if provided
                            if (options.onUpdate) {
                                options.onUpdate({
                                    wordCount: abstractWordCount,
                                    exceedsLimit: abstractWordCount > ABSTRACT_WORD_LIMIT,
                                    limit: ABSTRACT_WORD_LIMIT
                                });
                            }
                        }
                    };
                }
            })
        ];
    }
});